import Alpine from "alpinejs";
import intersect from '@alpinejs/intersect'

import navManager from "./navManager";
import statusManager from "./statusManager";
import draftManager from "./draftManager";

window.navManager = navManager;
window.statusManager = statusManager;
window.draftManager = draftManager;

window.Alpine = Alpine;
Alpine.plugin(intersect)
Alpine.start();
